/** Picks v2 or v1 of the Intensity Report page based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import IntensityReportPage   from './IntensityReportPage';
import IntensityReportPageV2 from './v2/IntensityReportPageV2';

export default function IntensityReportPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? IntensityReportPageV2 : IntensityReportPage;
  return <Component {...props} />;
}
